import { AMPLITUDE_EVENT } from '@sonar-software/sonar-analytics';
import { Button } from 'antd';
import { DeconstructedURL } from '@sonar-software/sonar-ts-lib';
import { LocalStorageKey } from '@sonar-software/sonar-ts-types';
import { FULL_ROUTES, SETTINGS_ORGANIZATION_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback, useMemo } from 'react';
import { useAmplitude, useAuthToken, useSalesforceAuth } from '@hooks';

function getRedirectState() {
	const { subdomain } = new DeconstructedURL(window.location.href);

	return subdomain;
}

export interface LinkSalesforceSandboxProps {
	key: string;
}

export const LinkSalesforceSandbox: React.FC<LinkSalesforceSandboxProps> = () => {
	const log = useAmplitude();
	const { organizationId } = useAuthToken();
	const redirectState = useMemo(getRedirectState, []);
	const { sandboxAuthRedirect } = useSalesforceAuth(FULL_ROUTES.CONFIRM_LINK, redirectState);

	const handleClick = useCallback(() => {
		log(AMPLITUDE_EVENT.NEW_SALESFORCE_SANDBOX_CLICKED);
		localStorage.setItem(LocalStorageKey.LastUsedOrg, organizationId?.toString() ?? '');
		sandboxAuthRedirect();
	}, [ log, organizationId, sandboxAuthRedirect ]);

	return (
		<Button
			id='link-salesforce-sandbox'
			onClick={ handleClick }>
			{ SETTINGS_ORGANIZATION_COPY.LINK_NEW_SALESFORCE_SANDBOX }
		</Button>
	);
};
